import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Menu from '../../components/Menu';
import React, { useCallback, useEffect, useState, useContext } from 'react'
import axios from 'axios';
import { LoadingContext } from "../../context/LoadingContext";
import Swal from 'sweetalert2'
const config = require('../../config.json')

export default function Packagebuy({ ipAddress, loginData }) {
    const [loading, setLoading] = useContext(LoadingContext);
    const [data, setData] = useState('')
    const [bal, setBal] = useState(0)

    const handlebuypack = (amt, pid) => {
        let data = JSON.stringify({
            "ip": ipAddress,
            "ulid": loginData.ulid,
            "amt": amt,
            "pack": pid,
        });
        Swal.fire('AK Herbal', "Please wait for geting Information", 'info')
        setLoading(true)
        console.log(data)
        let axiosConfig = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${config.baseUrl}/buy`,
            headers: {
                'ip': ipAddress,
                'ulid': loginData.ulid,
                'auth': loginData.auth,
                'token': loginData.token,
                'Content-Type': 'application/json'
            },
            data: data
        };
        axios.request(axiosConfig)
            .then((response) => {
                setLoading(false)
                console.log(response.data);
                let res = response.data;
                Swal.fire({
                    title: "AK Herbal",
                    icon: 'info',
                    text: res?.message
                })
                handleCall()
            })
            .catch((error) => {
                console.log(error);
            });
    }
    const handleCall = useCallback(() => {

        let data = JSON.stringify({
            "ip": ipAddress,
            "ulid": loginData.ulid
        });

        let axiosConfig = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${config.baseUrl}packages`,
            headers: {
                'ip': ipAddress,
                'ulid': loginData.ulid,
                'auth': loginData.auth,
                'token': loginData.token,
                'Content-Type': 'application/json'
            },
            data: data
        };
        axios.request(axiosConfig)
            .then((response) => {
                setData(response.data?.info)
                setBal(response.data?.info?.topup)
                console.log(response.data)
            })
            .catch((error) => {
                console.log(error);
            });
    }, [ipAddress, loginData.auth, loginData.token, loginData.ulid])
    useEffect(() => {
        handleCall()
    }, [handleCall])

    const handleValues = async (e, p) => {
        if (bal >= parseFloat(e) && bal > 0) {
            Swal.fire({
                title: "AK Herbal",
                icon: 'info',
                text: "Do you Want to Buy Package of Amount " + e
            }).then((res) => {
                if (res.isConfirmed) {
                    handlebuypack(e, p)
                }
            })
        }
        else {
            Swal.fire("AK Herbal", "Please Check You Topup Wallet. Your Balance :" + bal, "info");
        }
    }

    const handelRecived = async (id, pname) => {
        Swal.fire({
            title: "AK Herbal",
            icon: 'info',
            text: "Do you Recived Package of Name " + pname,
            showCancelButton: true,
            cancelButtonText: 'Not Recived Yet',
            confirmButtonText: 'Yes Recived',

        }).then((res) => {
            console.log(res.isConfirmed)
            if (res.isConfirmed) {
                let data = JSON.stringify({
                    "ip": ipAddress,
                    "ulid": loginData.ulid,
                    "pack": id,
                });
                //Swal.fire('AK Herbal', "Please wait for geting Information", 'info')
                setLoading(true)
                console.log(data)
                let axiosConfig = {
                    method: 'post',
                    maxBodyLength: Infinity,
                    url: `${config.baseUrl}/packrecived`,
                    headers: {
                        'ip': ipAddress,
                        'ulid': loginData.ulid,
                        'auth': loginData.auth,
                        'token': loginData.token,
                        'Content-Type': 'application/json'
                    },
                    data: data
                };
                axios.request(axiosConfig)
                    .then((response) => {
                        setLoading(false)
                        console.log(response.data);
                        let res = response.data;
                        Swal.fire({
                            title: "AK Herbal",
                            icon: 'info',
                            text: res?.message
                        })
                        handleCall()
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        });
    }
    return (
        <>
            <div className="layout-container">
                <Menu />
                <div className="layout-page">
                    <Header />
                    <div className="content-wrapper">
                        <div className="container-xxl flex-grow-1 container-p-y pt-2 mb-4">
                            <div>
                                <div className='row'>
                                    <div className="col-md-12  mb-2">
                                        <div className="card">
                                            <div className="card-header align-items-center ">
                                                <div className="card-title mb-0">
                                                    <h6 className="m-0 text-center text-black ">Buys Product Package</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-lg-4 col-md-6 col-sm-6 mb-2" key="n2">
                                        <div className="card">
                                            <div className="card-body dashinc">
                                                <div className="d-flex justify-content-between">
                                                    <div className="card-info">
                                                        <p className="card-text m-0 text-black text-sm">Topup Wallet Balance </p>
                                                        <div className="d-flex align-items-end mb-2">
                                                            <small className="text-black "><i className='bx bx-rupee bx-xs'></i>  {data?.topup}  </small>
                                                        </div>
                                                    </div>
                                                    <div className="card-icon">
                                                        <span className="badge bg-label-success rounded p-2">
                                                            <i className='bx bx-rupee bx-sm'></i>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    {data?.prodPack?.map((list, i) => {
                                        return (
                                            <>
                                                <div className="col-md-6  mb-2" id={i + 1} key={i + 1099}>
                                                    <div className="card">
                                                        <div className="card-body dashinc">
                                                            <h6 className='text-black text-center'>{list.package_name}</h6>
                                                            <p className="card-text m-0 text-black text-sm text-center mb-2">{list.package_info} </p>
                                                            <div className="d-flex justify-content-between">
                                                                <div className="card-info">
                                                                    <p className="card-text m-0 text-black text-sm"> MRP<i className='bx bx-rupee bx-xs'></i>{list.mrp} </p>
                                                                    <div className="d-flex align-items-end mb-2">
                                                                        <small className="text-black text-sm"><i className='bx bx-coin bx-xs'></i> BV {list.bv}  </small>
                                                                    </div>
                                                                </div>
                                                                <div className="card-info">

                                                                    <p className="card-text m-0 text-black text-sm"> DP<i className='bx bx-rupee bx-xs'></i>{list.dp} </p>
                                                                    <div className="d-flex align-items-end mb-2">
                                                                        <small className="text-black text-sm">GST <i className='bx bx-rupee bx-xs'></i>{list.gst} ({list.gst_per}%)  </small>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                            <div className="card-info align-items-center mb-2">
                                                                <div className='text-center mt-0'>
                                                                    <button className='btn  btn-success rounded-pill btn-sm' onClick={() => handleValues(list.dp, list.id)}>Buy {list.package_name} of <i className='bx bx-rupee bx-xs'></i>{list.dp}</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    })}
                                </div>
                                <div className='row'>
                                    <div className="col-md-12  mb-2">
                                        <div className="card">
                                            <div className="card-header align-items-center ">
                                                <div className="card-title mb-0">
                                                    <h6 className="m-0 me-2 text-center text-black">Buyed Packages</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        data?.prod?.map((list, index) => {
                                            return (
                                                <div className="col-md-4  mb-1" id={index + 1} key={index + 1}>
                                                    <div className="card h-100">
                                                        <div className="card-header align-items-center" style={{ padding: "3% 5% 3% 5%" }}>
                                                            <div className="col-md-12">
                                                                <div className='row d-flex justify-content-between'>
                                                                    <div className='col-6 text-left'>
                                                                        <span className="text-black text-sm">DP : <i className='bx bx-rupee bx-xs'></i> {list?.paid_amount}</span>
                                                                    </div>
                                                                    <div className='col-6' style={{ textAlignLast: "end" }}>
                                                                        <small className="text-sm">Buy Date : {list?.dt}</small>
                                                                    </div>
                                                                </div>
                                                                <div className='row d-flex justify-content-between'>
                                                                    <div className='col-6 text-left'>
                                                                        <small className="text-sm">Package Name  </small>
                                                                    </div>
                                                                    <div className='col-6' style={{ textAlignLast: "end" }}>
                                                                        <small className="text-sm">{list?.pname} </small>
                                                                    </div>
                                                                </div>
                                                                <div className='row d-flex justify-content-between'>
                                                                    <div className='col-8 text-left'>
                                                                        <small className="text-sm">MRP :<i className='bx bx-rupee bx-xs'></i>{list?.paid_mrp}</small>
                                                                    </div>
                                                                    <div className='col-4' style={{ textAlignLast: "end" }}>
                                                                        <small className="text-sm">BV <i className='bx bx-coin bx-xs'></i>{list?.paid_bv}</small>
                                                                    </div>
                                                                </div>
                                                                <div className='row d-flex justify-content-between'>
                                                                    <div className='col-6 text-left'>
                                                                        <small className="text-sm">{(list?.is_send == 1) ? 'Dispatched:Yes' : 'Dispatched:No'} </small>
                                                                    </div>
                                                                    <div className='col-6' style={{ textAlignLast: "end" }}>
                                                                        <small className="text-sm"> Dispatch Date :{list?.sdt}</small>
                                                                    </div>
                                                                </div>
                                                                {(list?.is_send == 1 && list?.is_recived == 0) ? <>
                                                                    <div className="card-info align-items-center mb-2">
                                                                        <div className='text-center mt-0'>
                                                                            <button className='btn  btn-info rounded-pill btn-xs' onClick={() => handelRecived(list.id, list.pname)}>Recived {list.panem} of <i className='bx bx-rupee bx-xs'></i>{list.paid_amount}</button>
                                                                        </div>
                                                                    </div></> : <></>}
                                                                <div className='row d-flex justify-content-between'>
                                                                    <div className='col-6 text-left'>
                                                                        <small className="text-sm">{(list?.is_recived == 1) ? 'Recived:Yes' : 'Recived:No'} </small>
                                                                    </div>
                                                                    <div className='col-6' style={{ textAlignLast: "end" }}>
                                                                        <small className="text-sm"> Recived Date :{list?.rdt}</small>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }

                                </div>
                                <div className='row'>
                                    <div className="col-md-12  mb-2">
                                        <div className="card">
                                            <div className="card-header align-items-center ">
                                                <div className="card-title mb-0">
                                                    <h6 className="m-0 me-2 text-center text-black">Buyed Products</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        data?.prodbuy?.map((list, index) => {
                                            return (
                                                <div className="col-md-4  mb-1" id={index + 1} key={index + 1}>
                                                    <div className="card h-100">
                                                        <div className="card-header align-items-center" style={{ padding: "3% 5% 3% 5%" }}>
                                                            <div className="col-md-12">
                                                                <div className='row d-flex justify-content-between'>
                                                                    <div className='col-6 text-left'>
                                                                        <span className="text-black text-sm">DP : <i className='bx bx-rupee bx-xs'></i> {list?.paid_amount}</span>
                                                                    </div>
                                                                    <div className='col-6' style={{ textAlignLast: "end" }}>
                                                                        <small className="text-sm">Buy Date : {list?.dt}</small>
                                                                    </div>
                                                                </div>
                                                                <div className='row d-flex justify-content-between'>
                                                                    <div className='col-6 text-left'>
                                                                        <small className="text-sm">Package Name  </small>
                                                                    </div>
                                                                    <div className='col-6' style={{ textAlignLast: "end" }}>
                                                                        <small className="text-sm">{list?.pname} </small>
                                                                    </div>
                                                                </div>
                                                                <div className='row d-flex justify-content-between'>
                                                                    <div className='col-8 text-left'>
                                                                        <small className="text-sm">MRP :<i className='bx bx-rupee bx-xs'></i>{list?.paid_mrp}</small>
                                                                    </div>
                                                                    <div className='col-4' style={{ textAlignLast: "end" }}>
                                                                        <small className="text-sm">BV <i className='bx bx-coin bx-xs'></i>{list?.paid_bv}</small>
                                                                    </div>
                                                                </div>
                                                                <div className='row d-flex justify-content-between'>
                                                                    <div className='col-6 text-left'>
                                                                        <small className="text-sm">{(list?.is_send == 1) ? 'Dispatched:Yes' : 'Dispatched:No'} </small>
                                                                    </div>
                                                                    <div className='col-6' style={{ textAlignLast: "end" }}>
                                                                        <small className="text-sm"> Dispatch Date :{list?.sdt}</small>
                                                                    </div>
                                                                </div>
                                                                {(list?.is_send == 1 && list?.is_recived == 0) ? <>
                                                                    <div className="card-info align-items-center mb-2">
                                                                        <div className='text-center mt-0'>
                                                                            <button className='btn  btn-info rounded-pill btn-xs' onClick={() => handelRecived(list.id, list.pname)}>Recived {list.panem} of <i className='bx bx-rupee bx-xs'></i>{list.paid_amount}</button>
                                                                        </div>
                                                                    </div></> : <></>}
                                                                <div className='row d-flex justify-content-between'>
                                                                    <div className='col-6 text-left'>
                                                                        <small className="text-sm">{(list?.is_recived == 1) ? 'Recived:Yes' : 'Recived:No'} </small>
                                                                    </div>
                                                                    <div className='col-6' style={{ textAlignLast: "end" }}>
                                                                        <small className="text-sm"> Recived Date :{list?.rdt}</small>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }

                                </div>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
        </>
    );
}